import { useTranslation } from 'react-i18next';
import { useRouteDocumentTitle } from '@client/toolkit';
import { useGetReportingPortfolioOverviewQuery } from '@client/api';

import { PageContentAnimation, WidgetsGrid, YearPicker } from '../../../components';
import { useYearParam } from '../../../hooks';
import { DashboardPaths } from '../dashboard.router';
import {
  PortfolioCompositionWidget,
  // PortfolioOperatingResultWidget,
  PortfolioTotalRentalIncomeWidget,
  PortfolioTotalOperatingResultWidget,
  PortfolioTotalInterestBearingDebtWidget,
  PortfolioValuationWidget,
  PortfolioEquityWidget,
} from './components';

export function DashboardPortfolioViewRoute() {
  const { t: routeT } = useTranslation('dashboard');
  useRouteDocumentTitle(routeT('dashboard.portfolio.documentTitle'), DashboardPaths.Portfolio);

  const { selectedYear, setSelectedYear } = useYearParam();

  // The widgets are fed by the building register and the financial report selected for the chosen
  // year; the year picker drives the query's calendar-year range. We use isFetching (not isLoading)
  // so the skeletons also show while refetching after a year change, not just on the first load.
  const { data, isFetching } = useGetReportingPortfolioOverviewQuery({
    startDate: selectedYear.startOf('year').format('YYYY-MM-DD'),
    endDate: selectedYear.endOf('year').format('YYYY-MM-DD'),
  });

  return (
    <PageContentAnimation className="flex flex-col gap-8">
      <div className="flex justify-start">
        <YearPicker value={selectedYear} onChange={setSelectedYear} />
      </div>
      <WidgetsGrid>
        {/* <PortfolioOperatingResultWidget data={data} isLoading={isFetching} /> */}
        <PortfolioTotalRentalIncomeWidget data={data} isLoading={isFetching} />
        <PortfolioTotalOperatingResultWidget data={data} isLoading={isFetching} />
        <PortfolioTotalInterestBearingDebtWidget data={data} isLoading={isFetching} />
        <PortfolioEquityWidget data={data} isLoading={isFetching} />
        <PortfolioCompositionWidget data={data} isLoading={isFetching} />
        <PortfolioValuationWidget data={data} isLoading={isFetching} />
      </WidgetsGrid>
    </PageContentAnimation>
  );
}
